import { Drawer, Descriptions, Divider } from 'antd';
import dayjs from 'dayjs';

function ViewDieSubCategory({ open, onClose, dieSubCategory }) {
  if (!dieSubCategory) {
    return null;
  }

  return (
    <Drawer
      title="Section Sub Category Details"
      width={700}
      onClose={onClose}
      open={open}
      footer={null}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Section Sub Category">
          {dieSubCategory.name || 'N/A'}
        </Descriptions.Item>
      </Descriptions>

      <Divider orientation="left">Audit Information</Divider>

      <Descriptions column={1} bordered>
        <Descriptions.Item label="Created At">
          {dieSubCategory.created_at
            ? dayjs(dieSubCategory.created_at).format('DD-MM-YYYY HH:mm:ss')
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Created By">
                {dieSubCategory.created_by && typeof dieSubCategory.created_by === 'object'
            ? `${dieSubCategory.created_by.first_name || ''} ${
                dieSubCategory.created_by.last_name || ''
              }`.trim() || 'N/A'
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {dieSubCategory.updated_at
            ? dayjs(dieSubCategory.updated_at).format('DD-MM-YYYY HH:mm:ss')
            : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Updated By">
          {dieSubCategory.updated_by && typeof dieSubCategory.updated_by === 'object'
            ? `${dieSubCategory.updated_by.first_name || ''} ${
                dieSubCategory.updated_by.last_name || ''
              }`.trim() || 'N/A'
            : 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </Drawer> 
  );
}

export default ViewDieSubCategory;
